/* eslint-disable @typescript-eslint/member-ordering */
import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, of, Subscription } from 'rxjs';
import { IStarbaseModularSearchField, StarbaseSearchComponent, TrackByUID, TruncateString } from 'starbase-launcher';
import { Battle } from '../models/battle';
import { BattleDataService } from '../services/battle-data.service';

class ExtendedModularSearchField<T> implements IStarbaseModularSearchField<T> {
  entityProps?: string[];
  fieldName: string;
  displayName?: string;
  default: boolean;
  enabled: boolean;
  filterClause: (value: T, search: string) => boolean;
}

@Component({
  selector: 'app-battle-search',
  templateUrl: './battle-search.component.html',
  styleUrls: ['./battle-search.component.css']
})
export class BattleSearchComponent extends StarbaseSearchComponent<Battle> implements OnInit, AfterViewInit, OnDestroy {
  @Input() placeholderText = 'Search Battles...';
  @Input() searchText = '';

  protected modularSearchFields: ExtendedModularSearchField<Battle>[] = [
    {
      displayName: 'name',
      fieldName: 'Name',
      entityProps: ['Name'],
      default: true,
      enabled: true,
      filterClause: (q: Battle, searchChars: string) => q && q.name && q.name.toLowerCase().includes(searchChars)
    }
  ];
  get fieldsEnabledCount(): number { return this.modularSearchFields.filter(f => f.enabled).length; }

  private allBattlesArray$: Observable<Battle[]>;
  private battlesSubscription: Subscription;

  hadText = this.getParentHadText;

  trackByUID = TrackByUID;

  constructor(private battleSvc: BattleDataService) {
    super();
    this.configLocked = true;
   }

  ngOnInit() {
    this.allBattlesArray$ = this.battleSvc.getAllData(this.battleSvc.getAllUri);
    this.battlesSubscription = this.allBattlesArray$.subscribe(d => this.data = d.map(_ => _ = new Battle().deserialize(_)));
    super.ngOnInit();
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  ngOnDestroy() {
    this.battlesSubscription.unsubscribe();
    super.ngOnDestroy();
  }

  outputModel(c: Battle) {
    super.outputModel(c);
    this.clearEvent();
    this.triggerFocus();
  }

  protected runSearch(searchChars: string): Observable<Battle[]> {
    console.log('Searching battles for ' + searchChars);
    const filters = this.enabledModularFilters();
    try {
      if (searchChars === '') {
        this.hadText = false;
        return of(this.data);
      }
      return of(this.data.filter(v => filters.some(f => f.filterClause(v, searchChars))));
    } catch (e) {
      console.error(e);
      this.errorOutput.emit();
      return of([]);
    }
  }

  public setTextToDisplay(m: Battle): string {
    if (!m) { return; }
    return m.name;
  }


}
